const authBody = () => {
  try {
    const raw = localStorage.getItem('userdata')
    const parsed = raw ? JSON.parse(raw) : {}
    return { userid: parsed.id || '', pid: parsed.pid || '' }
  } catch (err) {
    return { userid: '', pid: '' }
  }
}

const read = async (res) => {
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error((data && data.msg) || 'Ben could not answer')
  return data
}

const withAuth = (body = {}) => {
  const auth = authBody()
  const q = new URLSearchParams(auth)
  return { auth, q, body: { ...auth, ...body } }
}

export const benStatus = async () => {
  const { q } = withAuth()
  const res = await fetch(`/api/ben/status?${q}`)
  return read(res)
}

export const benHistory = async () => {
  const { q } = withAuth()
  const res = await fetch(`/api/ben/history?${q}`)
  return read(res)
}

export const talkToBen = async (message) => {
  let tz = ''
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '' } catch (_) {}
  const { body } = withAuth({ message, tz })
  const res = await fetch('/api/ben/talk', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  return read(res)
}

export const rateBen = async (id, value) => {
  const { body } = withAuth({ id, value })
  const res = await fetch('/api/ben/feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  return read(res)
}

export const teachBen = async (file) => {
  const { auth } = withAuth()
  const data = new FormData()
  data.append('userid', auth.userid)
  data.append('pid', auth.pid)
  data.append('file', file)
  const res = await fetch('/api/ben/learn', { method: 'POST', body: data })
  return read(res)
}

export const saveBenAccount = async (payload) => {
  const { body } = withAuth(payload)
  const res = await fetch('/api/ben/accounts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  return read(res)
}

// Address of a picture Ben made or was shown (only you can open it)
export const benImageUrl = (id) => {
  const q = new URLSearchParams(authBody())
  return `/api/ben/image/${encodeURIComponent(id)}?${q}`
}

// The browser opens the picture (any format), shrinks it, and sends Ben the raw pixels
const pictureToPixels = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => {
    const max = 224
    const scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight))
    const w = Math.max(8, Math.round(img.naturalWidth * scale))
    const h = Math.max(8, Math.round(img.naturalHeight * scale))
    const canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h
    const ctx = canvas.getContext('2d', { willReadFrequently: true })
    ctx.drawImage(img, 0, 0, w, h)
    const data = ctx.getImageData(0, 0, w, h).data
    resolve({ w, h, pixels: new Uint8Array(data.buffer.slice(0)), url })
  }
  img.onerror = () => {
    URL.revokeObjectURL(url)
    reject(new Error('I could not open that file as a picture.'))
  }
  img.src = url
})

export const showBen = async (file) => {
  const shot = await pictureToPixels(file)
  const { auth } = withAuth()
  const data = new FormData()
  data.append('userid', auth.userid)
  data.append('pid', auth.pid)
  data.append('w', String(shot.w))
  data.append('h', String(shot.h))
  data.append('name', file.name || '')
  data.append('pixels', new Blob([shot.pixels]), 'pixels.bin')
  const res = await fetch('/api/ben/see', { method: 'POST', body: data })
  const out = await read(res).catch((err) => {
    URL.revokeObjectURL(shot.url)
    throw err
  })
  return { ...out, previewUrl: shot.url }
}
